import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { IconButton, Tooltip } from "@mui/material";
import { useDelete, useResourceParams } from "@refinedev/core";
import { useQueryClient } from "@tanstack/react-query";

export const DeleteIconButton = ({
  recordItemId,
  resource,
  confirmTitle = "Supprimer ? Action définitive.",
  onSuccess,
}: {
  recordItemId: number | string;
  resource?: string;
  confirmTitle?: string;
  onSuccess?: () => void;
}) => {
  const { mutate, mutation } = useDelete();
  const { resource: ctxResource } = useResourceParams();
  const target = resource ?? ctxResource?.name;
  const queryClient = useQueryClient();

  return (
    <Tooltip title="Supprimer">
      <span>
        <IconButton
          color="error"
          size="small"
          disabled={mutation.isPending || !target}
          onClick={() => {
            if (!target) return;
            if (window.confirm(confirmTitle)) {
              mutate(
                { resource: target, id: recordItemId },
                {
                  onSuccess: () => {
                    queryClient.invalidateQueries();
                    onSuccess?.();
                  },
                },
              );
            }
          }}
        >
          <DeleteOutline fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};
